// Test de QUÉ TE INTERESA — de dónde salen los ejemplos.
//
// TIENE FORMA DE TEST Y NO ES UN TEST, y la diferencia decide cómo está escrito. Los otros
// cuatro preguntan indirecto porque averiguan algo que el alumno no sabe decir de sí mismo:
// qué mentor le encaja, por dónde empezar. Los intereses los sabe perfectamente. Preguntar
// «¿qué harías un sábado?» para deducir que le gusta el anime sería deducir lo que podía
// haber declarado, que es exactamente lo que A5 prohíbe. Así que aquí se MARCA.
//
// POR ESO ESTAS PREGUNTAS SON DE VARIAS RESPUESTAS (`tipo: "varias"` en el catálogo). No hay
// opción correcta y no hay tope: se respetan todos los intereses. Quien marca casi todo no
// está diciendo que le interese casi todo —está diciendo que no quiere elegir—, y eso lo
// resuelve `hay_senal()` en el servidor, no un límite en esta pantalla.
//
// Y NO HAY CAMPO LIBRE. La lista es cerrada, la misma que `TEMAS` en `domain/tests_alpha.py`
// (y la quinta pantalla, que son los cursos publicados).
// Un hueco donde un menor escriba lo que sea recoge cosas que esta plataforma no tiene por
// qué recoger, y además no sirve para elegir un ejemplo.
// CADA PANTALLA SE EXPLICA SOLA, y esto lo pidió Gabri el 4 de septiembre mirando la segunda.
// Ponía «Lo mismo aquí:» debajo de «Cómo funciona el mundo», y quien llega a esa pantalla sin
// acordarse de la anterior -o quien la abre de nuevas- no sabe qué se le está preguntando ni si
// puede marcar más de una. En un test las pantallas no se leen en fila: se leen de una en una,
// y cada una tiene que decir qué se pregunta y que se puede marcar varias.
export const PREGUNTAS_INTERES = [
  {
    id: "i1",
    prompt: "¿Qué te interesa de esto? Marca todas las que quieras, o ninguna.",
    question: "Historias y personajes",
    options: [
      { id: "a", label: "Anime y manga", weights: { "historias:anime": 1 } },
      { id: "b", label: "Series y cine", weights: { "historias:series": 1 } },
      { id: "c", label: "Libros y novelas", weights: { "historias:libros": 1 } },
      { id: "d", label: "Videojuegos con historia", weights: { "historias:videojuegos": 1 } },
      { id: "e", label: "Cómic y superhéroes", weights: { "historias:comic": 1 } },
      { id: "f", label: "Mitología y leyendas", weights: { "historias:mitologia": 1 } },
    ],
  },
  {
    id: "i2",
    prompt: "¿Y de esto? Otra vez: las que quieras, o ninguna.",
    question: "Cómo funciona el mundo",
    options: [
      { id: "a", label: "Animales y naturaleza", weights: { "mundo:animales": 1 } },
      { id: "b", label: "Espacio y universo", weights: { "mundo:espacio": 1 } },
      { id: "c", label: "Tecnología e inventos", weights: { "mundo:tecnologia": 1 } },
      { id: "d", label: "El cuerpo humano", weights: { "mundo:cuerpo": 1 } },
      { id: "e", label: "Coches, motos y máquinas", weights: { "mundo:maquinas": 1 } },
      { id: "f", label: "Medio ambiente", weights: { "mundo:ambiente": 1 } },
    ],
  },
  {
    id: "i3",
    prompt: "¿Qué te llama la atención aquí? Marca las que quieras.",
    question: "Gente y sociedad",
    options: [
      { id: "a", label: "Historia y civilizaciones", weights: { "gente:historia": 1 } },
      { id: "b", label: "Lo que pasa ahora", weights: { "gente:actualidad": 1 } },
      { id: "c", label: "Otras culturas y viajes", weights: { "gente:culturas": 1 } },
      { id: "d", label: "Arqueología y misterios del pasado", weights: { "gente:arqueologia": 1 } },
      { id: "e", label: "Cómo funciona el dinero", weights: { "gente:dinero": 1 } },
      { id: "f", label: "Ciudades y arquitectura", weights: { "gente:ciudades": 1 } },
    ],
  },
  {
    id: "i4",
    prompt: "La última: ¿qué te gusta hacer? Marca las que quieras.",
    question: "Hacer y competir",
    options: [
      { id: "a", label: "Deporte y equipos", weights: { "hacer:deporte": 1 } },
      { id: "b", label: "Música, tocar o escuchar", weights: { "hacer:musica": 1 } },
      { id: "c", label: "Baile", weights: { "hacer:baile": 1 } },
      { id: "d", label: "Dibujo y diseño", weights: { "hacer:dibujo": 1 } },
      { id: "e", label: "Cocina", weights: { "hacer:cocina": 1 } },
      { id: "f", label: "Foto y vídeo", weights: { "hacer:audiovisual": 1 } },
    ],
  },
  // LA QUINTA, LO QUE QUIERE ESTUDIAR (R5, 24 oct 2026), y no es para el mentor: lo marcado
  // sale primero en `/cursos` y lo ve su profesor. UNA CASILLA POR FAMILIA DE CURSOS PUBLICADOS
  // —«Inglés», «Lengua y literatura castellana»—, y por eso no lleva opciones escritas: las pone
  // `lib/cursosDelTest.mjs` con el catálogo del servidor al abrir el test, así que un curso nuevo
  // trae su casilla sin tocar este fichero. Si el catálogo no llega, la pantalla no sale. Sus
  // claves son `grupo:<clave>`.
  {
    id: "i5",
    prompt: "Y por último: ¿qué te gustaría estudiar? Saldrá primero en los cursos, y si vas con una clase lo verá tu profesor.",
    question: "Lo que te gustaría estudiar",
    opciones: "cursos-publicados",
    options: [],
  },
];
